
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Code, Preview } from "@lighting-beetle/lighter-styleguide";
import "./../styles/base/styleguide.scss";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Spacing utilities`}</h1>
    <h2>{`Reset classes`}</h2>
    <Preview hasCodePreview={false} mdxType="Preview">
  <p>
    Padding and margin resets remove padding/margin in the desired direction.
  </p>
  <ul>
    <li>
      <Code mdxType="Code">.pt-none</Code> removes top padding
    </li>
    <li>
      <Code mdxType="Code">.pr-none</Code> removes right padding
    </li>
    <li>
      <Code mdxType="Code">.pb-none</Code> removes bottom padding
    </li>
    <li>
      <Code mdxType="Code">.pl-none</Code> removes left padding
    </li>
  </ul>
  <ul>
    <li>
      <Code mdxType="Code">.mt-none</Code> removes top margin
    </li>
    <li>
      <Code mdxType="Code">.mr-none</Code> removes right margin
    </li>
    <li>
      <Code mdxType="Code">.mb-none</Code> removes bottom margin
    </li>
    <li>
      <Code mdxType="Code">.ml-none</Code> removes left margin
    </li>
  </ul>
    </Preview>
    <h2>{`Bottom margin`}</h2>
    <Preview hasCodePreview={false} mdxType="Preview">
  <p>Bottom margin utility classes help offset elements vertically.</p>
  <ul>
    <li>
      <Code mdxType="Code">.mb</Code> adds default bottom margin
    </li>
    <li>
      <Code mdxType="Code">.mb-small</Code> adds small bottom margin
    </li>
    <li>
      <Code mdxType="Code">.mb-large</Code> adds large bottom margin
    </li>
  </ul>
    </Preview>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;